import React, { useEffect, useState } from "react";
import { Button, Input, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import swal from "sweetalert";
import { AgGridReact } from "ag-grid-react";

import {
  AllCategoryList,
  DeleteCategory,
  Delete_SubCategory,
} from "../../ApiEndPoint/ApiCalling";

export default function CategorySubCategory() {
  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [activeTab, setActiveTab] = useState("category");
  const [loading, setLoading] = useState(false);

  // 🔥 FETCH DATA
  const fetchData = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("userData"));
      const res = await AllCategoryList(user?._id, user?.database);

      const categories = res?.Category || [];
      // ✅ Category
      setCategoryData(categories);

      // ✅ SubCategory flatten
      const subs = categories.flatMap((cat) =>
        (cat.subcategories || cat.subCategory || []).map((sub) => ({
          ...sub,

          // Category ki ID
          categoryId: cat._id,

          // Category ka name
          categoryName: cat.name,
        }))
      );

      setSubCategoryData(subs);

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔥 DELETE
  // const handleDelete = (id) => {
  //   swal("Warning", "Delete?", {
  //     buttons: ["Cancel", "Delete"],
  //   }).then(async (value) => {
  //     if (value) {
  //       try {
  //         if (activeTab === "category") {
  //           await DeleteCategory(id);
  //         } else {
  //           await Delete_SubCategory(id);
  //         }

  //         swal("Success", "Deleted Successfully", "success");
  //         fetchData();
  //       } catch {
  //         swal("Error", "Something went wrong", "error");
  //       }
  //     }
  //   });
  // };
  const handleDelete = (categoryId, subCategoryId) => {
    swal("Warning", "Delete?", {
      buttons: ["Cancel", "Delete"],
    }).then(async (value) => {
      if (value) {
        try {
          if (activeTab === "category") {
            await DeleteCategory(categoryId);
          } else {
            await Delete_SubCategory(
              categoryId,
              subCategoryId
            );
          }

          swal(
            "Success",
            "Deleted Successfully",
            "success"
          );

          fetchData();
        } catch (err) {
          console.log(err);

          swal(
            "Error",
            "Something went wrong",
            "error"
          );
        }
      }
    });
  };
  // 🔥 DATA SWITCH
  const rowData =
    activeTab === "category" ? categoryData : subCategoryData;

  // 🔥 COLUMNS SWITCH
  const columnDefs =
    activeTab === "category"
      ? [
        {
          headerName: "S.No",
          valueGetter: "node.rowIndex + 1",
          width: 80,
        },
        {
          headerName: "Category Name",
          field: "name",
          flex: 1,
        },
        {
          headerName: "Steps",
          flex: 1,
          valueGetter: (params) =>
            params?.data?.steps?.map((s) => s.step_Name).join(", ") || "-",
        },
        {
          headerName: "Status",
          field: "status",
          width: 120,
        },
        {
          headerName: "Actions",
          width: 180,
          cellRenderer: (params) => (
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                size="sm"
                color="primary"
                onClick={() =>
                  navigate(
                    `/production?view=add-category/${params?.data?._id}`, {
                    state: { data: params?.data }
                  }

                  )
                }
              >
                Edit
              </Button>

              <Button
                size="sm"
                color="danger"
                onClick={() => handleDelete(params?.data?._id)}
              >
                Delete
              </Button>
            </div>
          ),
        },
      ]
      : [
        {
          headerName: "S.No",
          valueGetter: "node.rowIndex + 1",
          width: 80,
        },
        {
          headerName: "SubCategory Name",
          field: "name",
          flex: 1,
        },
        {
          headerName: "Category",
          field: "categoryName",
          flex: 1,
        },
        {
          headerName: "Status",
          field: "status",
          width: 120,
        },
        {
          headerName: "Actions",
          width: 180,
          cellRenderer: (params) => (
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                size="sm"
                color="primary"
                onClick={() =>
                  navigate(
                    `/production?view=add-subcategory/${params.data._id}`,
                    {
                      state: { data: params.data },
                    }
                  )
                }
              >
                Edit
              </Button>

              <Button
                size="sm"
                color="danger"
                onClick={() =>
                  handleDelete(
                    params.data.categoryId,
                    params.data._id
                  )
                }
              >
                Delete
              </Button>
            </div>
          ),
        }
      ];

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="erp-page-grid">

      {/* 🔥 HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Category & SubCategory</h2>

        <div style={{ display: "flex", gap: "10px" }}>
          {/* 🔥 TOGGLE */}
          <Button
            color={activeTab === "category" ? "primary" : "secondary"}
            onClick={() => setActiveTab("category")}
          >
            Category
          </Button>

          <Button
            color={activeTab === "subcategory" ? "primary" : "secondary"}
            onClick={() => setActiveTab("subcategory")}
          >
            SubCategory
          </Button>
        </div>
      </div>

      {/* 🔥 ADD BUTTON */}
      <div style={{ marginTop: "10px" }}>
        {activeTab === "category" ? (
          <Button
            color="primary"
            onClick={() => navigate("/production?view=add-category")}
          >
            <FaPlus /> Add Category
          </Button>
        ) : (
          <Button
            color="success"
            onClick={() => navigate("/production?view=add-subcategory")}
          >
            <FaPlus /> Add SubCategory
          </Button>
        )}
      </div>

      {/* 🔥 SEARCH */}
      <Input
        placeholder="Search..."
        style={{ margin: "10px 0" }}
        onChange={(e) => {
          const val = e.target.value.toLowerCase();

          if (activeTab === "category") {
            setCategoryData((prev) =>
              prev.filter((item) =>
                item.name.toLowerCase().includes(val)
              )
            );
          } else {
            setSubCategoryData((prev) =>
              prev.filter((item) =>
                item.name.toLowerCase().includes(val)
              )
            );
          }
        }}
      />

      {/* 🔥 TABLE */}
      <div
        className="ag-theme-alpine"
        style={{ width: "100%", height: "500px" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
        />
      </div>
    </div>
  );
}